import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Home, FileText, CheckSquare, Upload, LogOut, BookOpen } from "lucide-react";
import { FaBell, FaClipboardCheck, FaCog } from "react-icons/fa";
import { MdHelpCenter } from "react-icons/md";
import { FaComments } from "react-icons/fa";

import "../../../assests/css/teachers/TeacherSidebar.css";

const TeacherSidebar = () => {

  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <>
      {/* Mobile Button */}
      <button className="ts-toggle-btn" onClick={toggleSidebar}>
        ☰
      </button>

      {/* Overlay */}
      {sidebarOpen && (
        <div className="ts-overlay" onClick={closeSidebar}></div>
      )}

      <aside className={`ts-sidebar ${sidebarOpen ? "ts-open" : ""}`}>

        <div className="ts-logo">
          <span>📘</span>
          <h2>GGCW Teacher</h2>
        </div>

        <ul className="ts-menu">

          <li>
            <NavLink to="/teacher/dashboard" onClick={closeSidebar}>
              <Home size={18} />
              <span>Dashboard</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/teacher/courses" onClick={closeSidebar}>
              <BookOpen size={18} />
              <span>My Courses</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/teacher/attendance" onClick={closeSidebar}>
              <CheckSquare size={18} />
              <span>Attendance</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/teacher/guesspaper" onClick={closeSidebar}>
              <Upload size={18} />
              <span>Notes</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/teacher/exam" onClick={closeSidebar}>
              <FileText size={18} />
              <span>Exams</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/teacher/myrequest" onClick={closeSidebar}>
              <FileText size={18} />
              <span>Teacherrequest</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/teacher/studentattendance" onClick={closeSidebar}>
              <FileText size={18} />
              <span>MY Students</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/teacher/result" onClick={closeSidebar}>
              <FaClipboardCheck size={18} />
              <span>Result</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/teacher/chats" onClick={closeSidebar}>
              <FaClipboardCheck size={18} />
              <span>Teacherdisputechat</span>
            </NavLink>
          </li>

          <li>
            <NavLink to="/teacher/helpsupport" onClick={closeSidebar}>
              <MdHelpCenter size={18} />
              <span>Help & Support</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/teacher/notification" onClick={closeSidebar}>
              <FaBell size={18} />
              <span>Notification</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/teacher/setting" onClick={closeSidebar}>
              <FaCog size={18} />
              <span>Settings</span>
            </NavLink>
          </li>
        </ul>

        <NavLink
          to="/teacher/logout"
          className="ts-logout"
          onClick={closeSidebar}
        >
          <LogOut size={18} />
          <span>Logout</span>
        </NavLink>

      </aside>
    </>
  );
};

export default TeacherSidebar;